import { render, staticRenderFns } from "./attributes.html?vue&type=template&id=6fd72a38&scoped=true&external"
import script from "./attributes.js?vue&type=script&lang=js&external"
export * from "./attributes.js?vue&type=script&lang=js&external"
import style0 from "./attributes.scss?vue&type=style&index=0&id=6fd72a38&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd72a38",
  null
  
)

export default component.exports